import { Box, Typography, Breadcrumbs } from "@mui/material";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const PageCover = ({ title, subtitle, breadcrumb, bgImage }) => {
  return (
    <Box
      sx={{
        height: { xs: "60vh", md: "60vh" },
        backgroundImage: bgImage ? `url(${bgImage})` : undefined,
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.65)",
        }}
      />

      <Box
        component={motion.div}
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        sx={{ position: "relative", textAlign: "center", color: "#fff", px: 2 }}
      >
        <Typography variant="h2" fontWeight={700}>
          {title}
        </Typography>

        <Typography sx={{ mt: 2, maxWidth: 600, mx: "auto" }}>
          {subtitle}
        </Typography>

        <Breadcrumbs aria-label="breadcrumb" className="bCrumbs">
          <Link to="/" style={{ color: "#ffc107" }}>
            Home
          </Link>
          <Typography color="white">{breadcrumb}</Typography>
        </Breadcrumbs>
      </Box>
    </Box>
  );
};

export default PageCover;
